module.exports = __webpack_public_path__ + "static/media/chiara.03368b4d.png";